<template>
	<transition name="erco-back-to-top-button-fade">
		<div
			v-if="buttonIsVisible"
			class="erco-back-to-top-button">
			<b-button
			      class="btn"
		          size="sm"
				  title="Nach oben"
				  @click="handleBackToTopClick">
				<span class="chevron"></span>
			</b-button>
		</div>
	</transition>
</template>

<script>

	export default {
		name: 'ErcoBackToTopButton',

		props: {
			visibilityThreshold: {
				type: Number,
				default: 0.1,
			},

			thresholdType: {
				type: String,
				default: 'percentual',
				validator: val => [
					'percentual',
					'windowHeight',
				].includes(val),
			},
		},

		data() {
			return {
				ticking: false,
				mainElements: [],
				buttonIsVisible: false,
			};
		},

		computed: {

		},

		methods: {
			handleScroll() {
				if (!this.ticking) {
					window.requestAnimationFrame(() => {
						this.evaluateScrollPosition(
							window.scrollY,
							document.body.scrollHeight,
							window.innerHeight,
						);
						this.ticking = false;
					});
				}
				this.ticking = true;
			},

			goBackToTop() {
				if (window.scrollTo) {
					window.scrollTo({ top: 0, behavior: 'smooth' });
					return;
				}

				this.mainElements.forEach((el) => { el.scrollTop = 0; });
			},

			evaluateScrollPosition(currentYScrollPosition, currentScrollHeight, windowInnerHeight) {
				switch (this.thresholdType) {
					case 'windowHeight':
						this.buttonIsVisible = windowInnerHeight <= currentYScrollPosition;
						break;

					case 'percentual':
					default:
						this.buttonIsVisible = (
							currentScrollHeight * this.visibilityThreshold
						) < currentYScrollPosition;
				}
			},

			handleBackToTopClick() {
				this.goBackToTop();
			},
		},

		mounted() {
			this.mainElements = Array.from(document.querySelectorAll('html, body'));
			window.addEventListener('scroll', this.handleScroll);
		},

		beforeDestroy() {
			window.removeEventListener('scroll', this.handleScroll);
		},
	};
</script>


<style lang="scss">

	.erco-back-to-top-button {
		position: fixed;
		bottom: 2rem;
		right: 2rem;
		box-shadow: 2px 2px 5px rgba(30, 30, 30, 0.2);
		z-index: 10000;

		.btn {
			height: 2rem;
			width: 2rem;
			padding: 0;
			display: flex;
			justify-content: center;

			.chevron {
				border-top: 2px solid #292b2c;
				border-right: 2px solid #292b2c;
				display: block;
				width: 10px;
				height: 10px;

				transform: translateY(20%) rotate(-45deg);
			}
		}
	}

	.erco-back-to-top-button-fade-enter-active,
	.erco-back-to-top-button-fade-leave-active {
		transition: opacity .3s, transform .5s;
	}

	.erco-back-to-top-button-fade-enter,
	.erco-back-to-top-button-fade-leave-to {
		opacity: 0;
		transform: translateY(-10px);
	}


</style>



// WEBPACK FOOTER //
// ErcoBackToTopButton.vue?16a70237